(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  class FaqItem extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[ref="trigger"]');
      this.content = this.querySelector('[ref="content"]');
      this.isOpen = false;
      
      this.init();
    }

    init() {
      this.trigger.addEventListener('click', () => this.toggle());
    }

    toggle() {
      this.isOpen = !this.isOpen;
      this.dataset.open = this.isOpen;
      this.trigger.setAttribute('aria-expanded', this.isOpen);
    }

    open() {
      this.isOpen = true;
      this.dataset.open = 'true';
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.isOpen = false;
      this.dataset.open = 'false';
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('faq-item-component', FaqItem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fomo-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const timer = document.querySelector('[data-fomo-countdown]');
    if (!timer) return;

    const durationHours = parseInt(timer.dataset.durationHours) || 24;
    let endTime = localStorage.getItem('fomoCountdownEnd');
    const now = Date.now();

    if (!endTime || now > parseInt(endTime)) {
      endTime = now + (durationHours * 60 * 60 * 1000);
      localStorage.setItem('fomoCountdownEnd', endTime.toString());
    }

    const updateDisplay = (remaining) => {
      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      const hoursEl = timer.querySelector('[data-unit="hours"]');
      const minutesEl = timer.querySelector('[data-unit="minutes"]');
      const secondsEl = timer.querySelector('[data-unit="seconds"]');

      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    };

    const tick = () => {
      const remaining = parseInt(endTime) - Date.now();
      if (remaining <= 0) {
        updateDisplay(0);
        localStorage.removeItem('fomoCountdownEnd');
        return;
      }
      updateDisplay(remaining);
      requestAnimationFrame(tick);
    };

    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gumlet-video-stories"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (!window.GUMLET_CONFIG) {
      window.GUMLET_CONFIG = {};
    }

      window.GUMLET_CONFIG.projectId = '{{ section.settings.gumlet_project_id | escape }}';

    if (!window.__gumletPlayerLoaded) {
      window.__gumletPlayerLoaded = true;
      var script = document.createElement('script');
      script.src = 'https://cdn.gumlet.com/gumlet.js/2.0/gumlet.min.js';
      script.async = true;
      document.head.appendChild(script);
    }

    document.addEventListener('DOMContentLoaded', function() {
      var section = document.querySelector('[data-section-id="{{ section.id }}"]');
      if (!section) return;

      var modal = section.querySelector('.gumlet-story-modal');
      var modalVideo = modal && modal.querySelector('.gumlet-story-modal__video');
      var storyButtons = section.querySelectorAll('.gumlet-story-chip');

      function closeModal() {
        if (!modal) return;
        modal.setAttribute('hidden', 'hidden');
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.removeAttribute('src');
          modalVideo.load();
        }
      }

      storyButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (!modal || !modalVideo) return;
          var videoSrc = btn.getAttribute('data-gumlet-video');
          var poster = btn.getAttribute('data-gumlet-poster');

          modal.removeAttribute('hidden');
          modalVideo.setAttribute('src', videoSrc);
          if (poster) {
            modalVideo.setAttribute('poster', poster);
          }
          modalVideo.play().catch(function() {});
        });
      });

      modal?.querySelectorAll('[data-close]').forEach(function(closeEl) {
        closeEl.addEventListener('click', closeModal);
      });

      document.addEventListener('keyup', function(e) {
        if (e.key === 'Escape') {
          closeModal();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-promo"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Debug: Log current page
    console.log('Popup script loaded, current path:', window.location.pathname);
    
    // Only show popup on home page
    if (window.location.pathname !== '/') {
      console.log('Not on home page, skipping popup');
      return;
    }
    
    console.log('On home page, checking popup elements...');
    
    // Configuration
    const config = {
      showDelay: 0, // Show immediately when page loads
      closeOnOverlay: true,
      closeOnEscape: true,
      rememberClosed: true, // Remember if user closed the popup
      cookieDays: 7 // Don't show again for 7 days after closing
    };

    // Elements
    const popup = document.getElementById('promo-popup');
    const overlay = popup?.querySelector('.promo-popup__overlay');
    const closeBtn = popup?.querySelector('.promo-popup__close');
    const form = popup?.querySelector('#promo-popup-form');

    console.log('Popup element found:', !!popup);
    console.log('Should show popup:', shouldShowPopup());

    if (!popup) {
      console.error('Popup element not found!');
      return;
    }

    // Check if popup should be shown
    function shouldShowPopup() {
      if (!config.rememberClosed) return true;
      
      const closedTime = localStorage.getItem('promo-popup-closed');
      if (!closedTime) return true;
      
      const daysSinceClosed = (Date.now() - parseInt(closedTime)) / (1000 * 60 * 60 * 24);
      return daysSinceClosed >= config.cookieDays;
    }

    // Show popup
    function showPopup() {
      console.log('showPopup() called, shouldShowPopup():', shouldShowPopup());
      if (!shouldShowPopup()) {
        console.log('Popup should not be shown (user closed it recently)');
        return;
      }
      
      console.log('Showing popup...');
      popup.style.display = 'flex';
      // Force reflow
      popup.offsetHeight;
      popup.classList.add('show');
      document.body.style.overflow = 'hidden';
      console.log('Popup should now be visible');
    }

    // Hide popup
    function hidePopup() {
      popup.classList.remove('show');
      
      setTimeout(() => {
        popup.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);

      if (config.rememberClosed) {
        localStorage.setItem('promo-popup-closed', Date.now().toString());
      }
    }

    // Event listeners
    closeBtn?.addEventListener('click', hidePopup);

    if (config.closeOnOverlay) {
      overlay?.addEventListener('click', hidePopup);
    }

    if (config.closeOnEscape) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('show')) {
          hidePopup();
        }
      });
    }

    // Form submission
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      
      const email = form.querySelector('input[type="email"]').value;
      if (!email) return;

      // Here you would typically send the email to your marketing service
      // For now, we'll just show a success message and close the popup
      
      // Show success state
      const button = form.querySelector('.promo-popup__button');
      const originalText = button.textContent;
      button.textContent = 'Inscription réussie!';
      button.style.background = '#22c55e';
      
      // Simulate API call
      setTimeout(() => {
        hidePopup();
        
        // Reset form after popup is hidden
        setTimeout(() => {
          form.reset();
          button.textContent = originalText;
          button.style.background = '';
        }, 500);
      }, 1500);
    });

    // Show popup immediately
    showPopup();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductTab extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[ref="trigger"]');
      this.content = this.querySelector('[ref="content"]');
      this.isOpen = this.dataset.open === 'true';
      
      this.init();
    }

    init() {
      this.trigger.addEventListener('click', () => this.toggle());
    }

    toggle() {
      this.isOpen = !this.isOpen;
      this.dataset.open = this.isOpen;
      this.trigger.setAttribute('aria-expanded', this.isOpen);
    }
  }

  customElements.define('product-tab-component', ProductTab);

  } catch(e) { console.error(e); }
})();
})();
